import {
    Layout,
    Button,
    Tree,
    Menu,
    Dropdown,
    Input,
    Modal,
    Checkbox,
    Pagination,
    message,
} from 'antd';
import {
    getFolderList,
    getSuspendedList,
    editFolder,
    deleteFolder,
    createFolder,
    editSuspended,
    storeBatchResource,
    getEnterpriseFolders,
    unbindEnterpriseLibraryResource,
    // deleteResource
} from '@/api/hdd/ceiling';
import CeilingBar from '@/components/CeilingBar';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import React, { useContext, useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { LoadingContext } from '&/components/LoadingComponent';
import CeilingModals from '@/components/CeilingModals';
import { debounce } from 'lodash';
import './index.scss';

const { Header, Sider, Content } = Layout;
const { Item } = Menu;
const { DirectoryTree } = Tree;

export default function CeilingComponentManage() {
    const loadingContext = useContext(LoadingContext);
    const history = useHistory();

    const ceilingBar = useRef();

    const [showCheckBox, setShowCheckBox] = useState(false);

    const [deleteOpen, setDeleteOpen] = useState(false);

    const [editOpen, setEditOpen] = useState(false);

    const [detailOpen, setDetailOpen] = useState(false);

    const [moveOpen, setMoveOpen] = useState(false);

    const [publishOpen, setPublishOpen] = useState(false);

    const [detail, setDetail] = useState({});

    const [folderId, setFolderId] = useState(0);

    const [keyword, setKeyword] = useState('');

    const [order, setOrder] = useState('');

    const [store, setStore] = useState(undefined);

    const [page, setPage] = useState(1);

    const [total, setTotal] = useState(0);

    const [didUpdate, forceUpdate] = React.useReducer(s => s + 1, 0); // forceUpdate 请求搜索

    const hasInput = useRef(false); // 是否有输入框

    const [expandedKeys, setExpandedKeys] = useState([]); // 展开树节点的key

    const [parentId, setParentId] = useState(undefined); // 父节点id

    const [activeTab, setActiveTab] = useState(() => {
        return localStorage.getItem('ceilingActiveTab') || 'ceiling';
    }); // 当前激活的tab，默认为吊顶

    const [publishTreeData, setPublishTreeData] = useState([]);

    const [publishTreeLoading, setPublishTreeLoading] = useState(false);

    const isUserForMarket = (() => {
        try {
            const data = JSON.parse(localStorage.getItem('HDDUserDataParams'));
            return +data?.userForMarket === 1;
        } catch {
            return false;
        }
    })();

    const activeTabRef = useRef(activeTab);

    // 存储每个tab的滚动位置
    const [siderScrollPositions, setSiderScrollPositions] = useState({
        ceiling: 0,
        custom: 0,
        other: 0,
    });

    useEffect(() => {
        activeTabRef.current = activeTab;
    }, [activeTab]);

    useEffect(() => {
        didUpdate > 0 && getResourceList();
    }, [didUpdate]);

    const goToPublicLibrary = () => {
        history.push('/hdd/customPublic');
    };

    const onAddComponent = () => {
        console.log('添加部件', activeTab);
        try {
            window.external.DispatchFun('XmlEditor', 'AddComponent', activeTab);
        } catch (e) {
            Promise.reject(e);
        }
    };

    const onExit = () => {
        console.log('退出');
        try {
            window.external.DispatchFun('XmlEditor', 'ExitAddComponent', '');

            localStorage.removeItem('HDDUserDataParams');
            localStorage.removeItem('ceilingActiveTab');
        } catch (e) {
            Promise.reject(e);
        }
    };

    const handleMore = e => {
        e.stopPropagation();
        e.preventDefault();
    };

    const [treeData, setTreeData] = useState([]);

    const [moveTreeData, setMoveTreeData] = useState([]);

    useEffect(() => {
        if (treeData.length === 0) return;

        let moveTree = JSON.parse(JSON.stringify(treeData));

        formatMoveTreeData(moveTree, 1, activeTab);

        setMoveTreeData(moveTree);
    }, [treeData, activeTab]);

    // 当treeData更新时，恢复当前tab的滚动位置
    // useEffect(() => {
    //     if (treeData.length > 0) {
    //         restoreScrollPosition(activeTab);
    //     }
    // }, [treeData, activeTab]);

    const getFolderData = (tab = activeTab) => {
        const params = {
            pid: null,
            checkToken: true,
            module: 'XmlEditor',
        };

        // 根据 tab 设置 type 参数
        if (tab === 'custom') {
            params.type = 7;
        } else if (tab === 'other') {
            params.type = 6;
        }

        return getFolderList(params).then(res => {
            let tree = res.data;

            formatTreeData(tree);

            setTreeData(tree);

            return tree;
        });
    };

    useEffect(() => {
        getFolderData().then(tree => {
            setParentId(tree[0].id);

            setFolderId(tree[0].id);
            // getResourceList();
            forceUpdate();

            setExpandedKeys(tree.map(item => item.key));
        });

        document.addEventListener('click', function (e) {
            if (!hasInput.current) return;

            if (
                e.target.classList.contains('edit-wrap') ||
                e.target.classList.contains('edit-input')
            ) {
                console.log('yt 部件编辑器管理后台创建分类点击了自己');
                return;
            } else if (e.target.classList.contains('more-visible')) {
                return;
            } else {
                onSave(currentNode.current);
            }
        });

        document.oncontextmenu = function (event) {
            // 阻止右键菜单
            event.preventDefault();
        };

        // hdd 客户端主动调用
        window.freshData = () => {
            forceUpdate();
        };

        return () => {
            document.oncontextmenu = null;
        };
    }, []);

    const changeNode = (key, value, data) =>
        data.forEach(item => {
            if (item.key === key) {
                item.value = value;
            }
            if (item.children) {
                changeNode(key, value, item.children);
            }
        });

    const onChange = (e, key) => {
        e.stopPropagation();
        changeNode(key, e.target.value, treeData);
        setTreeData([...treeData]);
    };

    const formatTreeData = (obj, level = 1) => {
        for (var i in obj) {
            obj[i].isEditable = false;
            obj[i].value = obj[i].name;
            obj[i].defaultValue = obj[i].name;
            obj[i].title = obj[i].value;
            obj[i].key = obj[i].id;
            obj[i].level = level;
            obj[i].className = level >= 2 ? `tree-level-${level}` : undefined;
            obj[i].children =
                obj[i].son && obj[i].son.length > 0 ? obj[i].son : [];
            if (obj[i].children && obj[i].children.length > 0) {
                formatTreeData(obj[i].children, level + 1);
                obj[i].isLeaf = false;
            } else {
                obj[i].isLeaf = true;
            }
        }
    };

    const formatMoveTreeData = (obj, level = 1, tab = activeTab) => {
        for (var i in obj) {
            obj[i].isEditable = false;
            obj[i].value = obj[i].name;
            obj[i].defaultValue = obj[i].name;
            obj[i].title = obj[i].value;
            obj[i].key = obj[i].id;
            obj[i].level = level;
            obj[i].className = level >= 2 ? `tree-level-${level}` : undefined;
            obj[i].children =
                obj[i].son && obj[i].son.length > 0 ? obj[i].son : [];
            if (obj[i].children && obj[i].children.length > 0) {
                formatMoveTreeData(obj[i].children, level + 1, tab);
                obj[i].isLeaf = false;
            } else {
                obj[i].isLeaf = true;
            }
            obj[i].selectable =
                tab === 'custom' ? level > 1 && obj[i].isLeaf : level > 1;
        }
    };

    const fetchPublishTreeData = () => {
        setPublishTreeLoading(true);
        return getEnterpriseFolders()
            .then(res => {
                const raw = Array.isArray(res?.data)
                    ? res.data
                    : res?.data?.list || [];
                const tree = Array.isArray(raw) ? raw : [];
                formatMoveTreeData(tree);
                setPublishTreeData(tree);
                return tree;
            })
            .catch(() => {
                setPublishTreeData([]);
            })
            .finally(() => {
                setPublishTreeLoading(false);
            });
    };

    const onSave = (nodeData, tab = activeTabRef.current) => {
        console.log('tab activeTabRef', tab);

        if (!nodeData) return;

        selectFlag.current = true;

        loadingContext.toggleSpin();

        if (!nodeData.value) {
            message.error('请输入分类名称');

            loadingContext.toggleSpin();

            return;
        }

        let apiName = nodeData.is_new === 1 ? createFolder : editFolder;

        const params = {
            pid: nodeData.pid,
            name: nodeData.value,
            id: nodeData.id,
            checkToken: true,
            module: 'XmlEditor',
        };

        // 根据 tab 设置 type 参数
        if (tab === 'custom') {
            params.type = 7;
        } else if (tab === 'other') {
            params.type = 6;
        }

        apiName(params)
            .then(() => {
                return getFolderData(tab);
            })
            .catch(() => {
                console.log('请求失败');

                setTreeData(prev => {
                    formatTreeData(prev);
                    return [...prev];
                });
            })
            .finally(() => {
                hasInput.current = false;

                loadingContext.toggleSpin();
            });
    };

    const editNode = (key, data) => {
        data.forEach(item => {
            //   return
            item.isEditable = item.key === key;
            //Tip: Must have, when a node is editable, and you click a button to make other node editable, the node which you don't save yet will be not editable, and its value should be defaultValue
            item.value = item.defaultValue; // 当某节点处于编辑状态，并改变数据，点击编辑其他节点时，此节点变成不可编辑状态，value 需要回退到 defaultvalue
            if (item.children) {
                item.children = editNode(key, item.children);
            }
        });
        return data;
    };

    const onEdit = (key, defaultValue, e) => {
        if (e) {
            e.domEvent.stopPropagation();
        }

        hasInput.current = true;

        setTreeData(prev => {
            let NEXT = [...prev];
            NEXT = editNode(key, NEXT);
            return NEXT;
        });
    };

    const deleteTreeNode = (key, tab = activeTab) => {
        const params = {
            id: key,
            checkToken: true,
            module: 'XmlEditor',
        };

        // 根据 tab 设置 type 参数
        if (tab === 'custom') {
            params.type = 7;
        } else if (tab === 'other') {
            params.type = 6;
        }

        return deleteFolder(params).then(() => {
            return getFolderData(tab);
        });
    };

    const findTopLevelAncestor = targetKey => {
        const searchInChildren = (children, key) => {
            for (const child of children) {
                if (child.key === key) return true;
                if (child.children && searchInChildren(child.children, key))
                    return true;
            }
            return false;
        };
        for (const node of treeData) {
            if (
                node.key === targetKey ||
                searchInChildren(node.children || [], targetKey)
            ) {
                return node;
            }
        }
        return null;
    };

    const onDelete = (key, e) => {
        if (e) {
            e.domEvent.stopPropagation();
        }

        Modal.confirm({
            title: intl.get('base.warning'),
            icon: <ExclamationCircleOutlined />,
            content: intl.get('directory.deleteConfirm'),
            centered: true,
            okText: intl.get('base.confirm'),
            cancelText: intl.get('base.cancel'),
            wrapClassName: 'delete-tree-node-modal',
            className: 'delete-tree-node-modal',
            onOk(close) {
                const isSelected = folderId === key;
                const topAncestor = isSelected
                    ? findTopLevelAncestor(key)
                    : null;
                deleteTreeNode(key, activeTab)
                    .then(() => {
                        if (topAncestor && topAncestor.key !== key) {
                            setFolderId(topAncestor.key);
                            setParentId(topAncestor.key);
                            setPage(1);
                            forceUpdate();
                        }
                    })
                    .finally(close);
            },
        });
    };

    const titleMenu = nodeData => {
        const canAddSubClass =
            activeTab === 'custom' &&
            [2, 3].includes(nodeData.level) &&
            !!nodeData.id;
        const isOriginNode = +nodeData.isOrigin === 1;
        const canRename = !isOriginNode;
        const canDelete = !isOriginNode;

        return (
            <Menu>
                {canAddSubClass && (
                    <Menu.Item
                        key="add"
                        onClick={e => {
                            e.domEvent?.stopPropagation();
                            onAddDebounce(nodeData);
                        }}>
                        新建子类
                    </Menu.Item>
                )}
                {canRename && (
                    <Menu.Item
                        key="rename"
                        onClick={e =>
                            onEdit(nodeData.id, nodeData.defaultValue, e)
                        }>
                        重命名
                    </Menu.Item>
                )}
                {canDelete && (
                    <Menu.Item
                        key="delete"
                        onClick={e => onDelete(nodeData.id, e)}>
                        删除
                    </Menu.Item>
                )}
            </Menu>
        );
    };

    const selectFlag = useRef(true);

    const currentNode = useRef(null);

    const addNode = (nodeData, data) => {
        data.forEach(item => {
            if (item.key === nodeData.key) {
                item.children = item.children || [];
                const nextLevel = (nodeData.level || 0) + 1;
                item.children.push({
                    key: item.key + Math.random(),
                    value: '未命名',
                    defaultValue: '未命名',
                    isEditable: true,
                    is_new: 1,
                    pid: nodeData.id,
                    level: nextLevel,
                    className:
                        nextLevel >= 3 ? `tree-level-${nextLevel}` : undefined,
                    children: [],
                    isLeaf: true,
                });
                item.isLeaf = false;
            }
            if (item.children) {
                addNode(nodeData, item.children);
            }
        });
        return data;
    };

    const onAdd = (nodeData, e) => {
        console.log('yt onAdd, 点击了');

        if (e && e.stopPropagation) {
            e.stopPropagation();
        }
        if (e && e.preventDefault) {
            e.preventDefault();
        }

        if (!expandedKeys.includes(nodeData.key)) {
            let next = JSON.parse(JSON.stringify(expandedKeys));
            next.push(nodeData.key);
            setExpandedKeys(next);
        }

        if (hasInput.current) {
            onSave(currentNode.current);

            return;
        }

        setTreeData(prev => {
            let NEXT = [...prev];
            NEXT = addNode(nodeData, NEXT);
            return NEXT;
        });
        hasInput.current = true;
    };

    const onAddDebounce = debounce(onAdd, 500);

    const titleRender = nodeData => {
        const isCustomSecondLevel =
            activeTab === 'custom' && nodeData.level === 2 && !!nodeData.id;
        const isCustomThirdLevel =
            activeTab === 'custom' && nodeData.level === 3 && !!nodeData.id;
        const hasChildren = nodeData.children && nodeData.children.length > 0;
        const showDropdown =
            isCustomSecondLevel ||
            isCustomThirdLevel ||
            (!hasChildren && +nodeData.isOrigin !== 1);
        const isExpanded = expandedKeys.includes(nodeData.key);

        const handleToggleExpand = e => {
            e.stopPropagation();
            setExpandedKeys(prev => {
                const nextSet = new Set(prev);
                if (nextSet.has(nodeData.key)) {
                    nextSet.delete(nodeData.key);
                } else {
                    nextSet.add(nodeData.key);
                }
                return Array.from(nextSet);
            });
        };

        if (nodeData.isEditable) {
            return (
                <span
                    onClick={e => e.stopPropagation()}
                    className="edit-wrap"
                    style={{ overflow: 'hidden' }}>
                    <Input
                        ref={function (input) {
                            if (input != null) {
                                if (selectFlag.current) {
                                    selectFlag.current = false;
                                    input.select();
                                }
                                // selectFlag.current = false;
                                // input.select();
                                input.focus();
                                currentNode.current = nodeData;
                            }
                        }}
                        maxLength={30}
                        size="mini"
                        className="edit-input"
                        value={nodeData.value}
                        onChange={e => onChange(e, nodeData.key)}
                        onPressEnter={() => onSave(nodeData)}
                    />

                    {/* <Icon type='close' style={{ marginLeft: 10 }} onClick={() => onClose(item.key, item.defaultValue)} />
                    <Icon type='check' style={{ marginLeft: 10 }} onClick={() => onSave(item.key)} /> */}
                </span>
            );
        } else {
            return (
                <>
                    <div className="left">
                        {(isCustomSecondLevel || isCustomThirdLevel) &&
                            hasChildren && (
                                <span
                                    className={`toggle-expand-btn ${
                                        isExpanded ? 'expanded' : 'collapsed'
                                    } ${
                                        folderId === nodeData.key
                                            ? 'active'
                                            : ''
                                    }`}
                                    onClick={handleToggleExpand}
                                />
                            )}
                        <div className="text-wrap">
                            <div className="hide-text">{nodeData.value}</div>
                            <div className={`text-no-wrap title`}>
                                {nodeData.value}
                            </div>
                        </div>
                    </div>
                    {nodeData.level === 1 && !isCustomSecondLevel && (
                        <i
                            className="icon-plus outlined more more-visible"
                            onClick={e => {
                                e.stopPropagation();
                                onAddDebounce(nodeData, e);
                            }}></i>
                    )}
                    {showDropdown && (
                        <Dropdown
                            overlay={titleMenu(nodeData)}
                            trigger={['click']}
                            getPopupContainer={() =>
                                document.querySelector('.ceiling-tree')
                            }
                            className="directory-dropdown">
                            <i
                                className="icon-more-h filled more"
                                onClick={event => handleMore(event)}></i>
                        </Dropdown>
                    )}
                </>
            );
        }
    };

    const viewDetailItem = item => {
        setDetailOpen(true);
    };

    const editInfoItem = item => {
        setEditOpen(true);
    };

    const upShelfItem = item => {
        editSuspended({ sourceCode: item.code, store: 1 }).then(() => {
            message.success('上架成功');
            forceUpdate();
        });
    };

    const downShelfItem = item => {
        editSuspended({ sourceCode: item.code, store: 0 }).then(() => {
            message.success('下架成功');
            forceUpdate();
        });
    };

    const moveItem = item => {
        setMoveOpen(true);
    };

    const publishItem = item => {
        setDetail(item);
        setPublishOpen(true);
        if (publishTreeData.length === 0 && !publishTreeLoading) {
            fetchPublishTreeData();
        }
    };

    const unpublishItem = item => {
        if (!item?.code) {
            message.error('未找到素材信息');
            return;
        }

        unbindEnterpriseLibraryResource({ sourceCode: item.code })
            .then(() => {
                message.success('已取消公开');
                forceUpdate();
            })
            .catch(() => {
                message.error('取消公开失败');
            });
    };

    const onMultiDelete = () => {
        let id = list.filter(item => item.selectedAll).map(item => item.id);
        setDetail({ id });
        setDeleteOpen(true);
    };

    const onMultiMove = () => {
        let codes = list
            .filter(item => item.selectedAll)
            .map(item => item.code);
        setDetail({ code: codes });
        setMoveOpen(true);
    };

    const onMultiUpShelf = async ids => {
        try {
            let codes = list
                .filter(item => item.selectedAll)
                .map(item => item.code);
            await storeBatchResource({
                sourceCodes: codes,
                store: 1,
                checkToken: true,
            });

            message.success(`批量上架成功，共${ids.length}个项目`);
            forceUpdate();
            // 取消全选状态
            ceilingBar.current?.setIsShowOperateBtn(false);
        } catch (error) {
            message.error('批量上架失败');
        }
    };

    const onMultiDownShelf = async ids => {
        try {
            let codes = list
                .filter(item => item.selectedAll)
                .map(item => item.code);

            await storeBatchResource({
                sourceCodes: codes,
                store: 0,
                checkToken: true,
            });

            message.success(`批量下架成功，共${ids.length}个项目`);
            forceUpdate();
            // 取消全选状态
            ceilingBar.current?.setIsShowOperateBtn(false);
        } catch (error) {
            message.error('批量下架失败');
        }
    };

    const handleClickMenu = (e, item) => {
        let actionOjb = {
            0: viewDetailItem,
            1: editInfoItem,
            2: upShelfItem,
            3: moveItem,
            4: deleteItem,
            5: downShelfItem,
        };

        setDetail(item);

        if (e.key === '6') {
            if (activeTab !== 'custom') {
                return;
            }

            if (+item.publish === 1) {
                unpublishItem(item);
            } else {
                publishItem(item);
            }

            return;
        }

        actionOjb[e.key](item);
    };

    const menu = item => (
        <Menu onClick={e => handleClickMenu(e, item)}>
            <Item key={0}>查看详情</Item>
            <Item key={1}>编辑信息</Item>
            {+item.store !== 1 ? (
                <Item key={2}>上架</Item>
            ) : (
                <Item key={5}>下架</Item>
            )}
            <Item key={3}>移动</Item>
            <Item key={4}>删除</Item>
            {activeTab === 'custom' && isUserForMarket && (
                <Item key={6}>{+item.publish === 1 ? '不公开' : '公开'}</Item>
            )}
        </Menu>
    );

    const [list, setList] = useState([]);

    const getResourceList = (tab = activeTab) => {
        const params = {
            parentId: /* tab === 'custom' ? undefined : */ parentId,
            folderId: /*  tab === 'custom' ? folderId :  */ parentId
                ? undefined
                : folderId,
            keyword,
            order,
            store,
            page,
            pageSize: 24,
            checkToken: !hasInput.current, //在创建分类的时候，点击了其他分类，会触发多次校验，此处修改为了只触发一次修改
            module: 'XmlEditor',
        };

        // 根据 tab 设置 type 参数
        if (tab === 'custom') {
            params.type = 7;
        } else if (tab === 'other') {
            params.type = 6;
        }

        getSuspendedList(params).then(res => {
            let list = res.data.list;
            list.map(item => {
                item.selectedAll = false;
                return item;
            });
            setList(list);
            setTotal(res.data.total);
        });
    };

    const onSelect = (keys, info) => {
        console.log('yt onSelect hasInput', hasInput.current);

        if (info.node.children && info.node.children.length > 0) {
            setPage(1);
            setFolderId(info.node.key);
            setParentId(info.node.key);
            forceUpdate();
            return;
        } else {
            setPage(1);
            setParentId(undefined);
            setFolderId(info.node.key);
            forceUpdate();
        }
    };

    const onClickImage = item => {
        console.log('点击图片', item);
        let obj = {
            xmlFile: item.filePath,
            title: item.name || item.fileName,
            sourceCode: item.code,
            locationType: item.locationType,
            ObjOffGround: item.heightToGround,
            categoryCode: item.categoryCode,
            fileType: activeTab,
            origin: '1', // 1 企业库 2 公库
        };
        try {
            window.external.DispatchFun(
                'XmlEditor',
                'DownLoadProject',
                JSON.stringify(obj)
            );
        } catch (e) {
            Promise.reject(e);
        }
    };

    const onCheckBoxChange = (e, item) => {
        setList(
            list.map(i => {
                if (i.id === item.id) {
                    i.selectedAll = e.target.checked;
                }
                return i;
            })
        );
    };

    useEffect(() => {
        if (ceilingBar.current) {
            if (!list || list.length === 0) {
                ceilingBar.current.setSelectedAll(false);
            } else {
                ceilingBar.current.setSelectedAll(
                    list.every(item => item.selectedAll)
                );
            }
            ceilingBar.current.setIndeterminate(
                list.some(item => item.selectedAll) &&
                    !list.every(item => item.selectedAll)
            );
        }
    }, [list]);

    const deleteItem = () => {
        setDeleteOpen(true);
    };

    const onPageChange = (page, pageSize) => {
        setPage(page);
        forceUpdate();
    };

    const getParentNode = (currentElement, parentClass) => {
        // 循环向上查找父元素，直到找到具有指定 class 名的父元素为止
        var parentElement = currentElement.parentNode;
        while (parentElement) {
            // 检查父元素是否包含指定的 class
            if (parentElement.classList.contains(parentClass)) {
                // 找到符合条件的父元素，输出其信息或进行其他操作
                console.log(
                    '找到指定 class 名为 ' + parentClass + ' 的父元素：',
                    parentElement
                );
                break;
            }
            // 继续向上查找
            parentElement = parentElement.parentNode;
        }
        return parentElement;
    };

    const triggerCheckBox = e => {
        let parent = getParentNode(e.target, 'card');

        parent.querySelector('input').click();
    };

    const onExpand = keys => {
        setExpandedKeys(keys);
    };

    // 保存当前tab的滚动位置
    const saveCurrentScrollPosition = currentTab => {
        const siderElement = document.querySelector('.ceiling-tree');
        if (siderElement) {
            setSiderScrollPositions(prev => ({
                ...prev,
                [currentTab]: siderElement.scrollTop,
            }));
        }
    };

    // 恢复指定tab的滚动位置
    const restoreScrollPosition = tab => {
        setTimeout(() => {
            const siderElement = document.querySelector('.ceiling-tree');
            if (siderElement && siderScrollPositions[tab] !== undefined) {
                siderElement.scrollTop = siderScrollPositions[tab];
            }
        }, 100); // 延迟执行，确保DOM已更新
    };

    const handleTabChange = tab => {
        // 保存当前tab的滚动位置
        saveCurrentScrollPosition(activeTab);

        setActiveTab(tab);
        localStorage.setItem('ceilingActiveTab', tab);
        setPage(1);
        // 重新获取数据，传入新的tab值
        getFolderData(tab).then(tree => {
            if (tree && tree.length > 0) {
                setParentId(tree[0].id);
                setFolderId(tree[0].id);
                forceUpdate();
                setExpandedKeys(tree.map(item => item.key));

                // 恢复新tab的滚动位置
                restoreScrollPosition(tab);
            }
        });
    };

    return (
        <div className="ceiling-component-manage">
            <Layout>
                <Header>
                    <div className="header-title">部件编辑器</div>
                    <div className="header-tabs">
                        <div
                            className={`tab-item ${
                                activeTab === 'ceiling' ? 'active' : ''
                            }`}
                            onClick={() => handleTabChange('ceiling')}>
                            吊顶
                        </div>
                        <div
                            className={`tab-item ${
                                activeTab === 'custom' ? 'active' : ''
                            }`}
                            onClick={() => handleTabChange('custom')}>
                            全屋定制
                        </div>
                        <div
                            className={`tab-item ${
                                activeTab === 'other' ? 'active' : ''
                            }`}
                            onClick={() => handleTabChange('other')}>
                            硬装造型
                        </div>
                    </div>
                    <div className="btn-wrap">
                        {activeTab === 'custom' && isUserForMarket && (
                            <Button
                                type="primary"
                                className="btn"
                                onClick={goToPublicLibrary}>
                                公库
                            </Button>
                        )}
                        <Button
                            type="primary"
                            className="btn"
                            onClick={onAddComponent}>
                            创建素材
                        </Button>
                        <Button className="btn" onClick={onExit}>
                            退出
                        </Button>
                    </div>
                </Header>
                <Layout>
                    <Sider
                        width={220}
                        className={`ceiling-tree${
                            activeTab === 'custom' ? ' custom-tree' : ''
                        }`}>
                        {treeData.length > 0 && (
                            <DirectoryTree
                                treeData={treeData}
                                defaultExpandAll
                                titleRender={titleRender}
                                onSelect={onSelect}
                                selectedKeys={[folderId]}
                                expandedKeys={expandedKeys}
                                onExpand={onExpand}
                            />
                        )}
                    </Sider>
                    <Content>
                        <div className="filter">
                            <CeilingBar
                                ref={ceilingBar}
                                onIsShowOperateBtnChange={flag =>
                                    setShowCheckBox(flag)
                                }
                                onSearch={keyword => {
                                    setKeyword(keyword);
                                    setPage(1);
                                    forceUpdate();
                                }}
                                onOrder={order => {
                                    setOrder(order);
                                    forceUpdate();
                                }}
                                onCheckBoxChange={store => {
                                    setStore(store);
                                    setPage(1);
                                    forceUpdate();
                                }}
                                list={list}
                                setList={setList}
                                onMultiDelete={onMultiDelete}
                                onMultiMove={onMultiMove}
                                onMultiUpShelf={onMultiUpShelf}
                                onMultiDownShelf={onMultiDownShelf}
                            />
                        </div>
                        {list.length > 0 ? (
                            <>
                                <div className="card-wrap">
                                    {list.map(item => (
                                        <div className="card" key={item.id}>
                                            <div
                                                className="card-img"
                                                onClick={e =>
                                                    showCheckBox
                                                        ? triggerCheckBox(e)
                                                        : onClickImage(item)
                                                }
                                                style={{
                                                    backgroundImage: `url(${item.thumbnail})`,
                                                    color: '#fff',
                                                }}>
                                                {+item.store === 0 && (
                                                    <div className="tip">
                                                        <img
                                                            src={
                                                                require('@/assets/img/hdd/approval.png')
                                                                    .default
                                                            }></img>
                                                        <span>待上架</span>
                                                    </div>
                                                )}
                                                {showCheckBox && (
                                                    <Checkbox
                                                        onChange={e =>
                                                            onCheckBoxChange(
                                                                e,
                                                                item
                                                            )
                                                        }
                                                        onClick={e =>
                                                            e.stopPropagation()
                                                        }
                                                        checked={
                                                            item.selectedAll
                                                        }></Checkbox>
                                                )}
                                            </div>
                                            <div className="bottom-wrap">
                                                <div className="card-title">
                                                    {item.name}
                                                </div>
                                                <div className="card-btn-wrap">
                                                    <Dropdown
                                                        overlay={menu(item)}>
                                                        <span className="filled icon-more-h"></span>
                                                    </Dropdown>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <Pagination
                                    total={total}
                                    showTotal={total => `共 ${total} 条`}
                                    pageSize={24}
                                    current={page}
                                    responsive={false}
                                    showSizeChanger={false}
                                    onChange={onPageChange}
                                />
                            </>
                        ) : (
                            <div className="no-data">
                                <div>
                                    <img
                                        src={
                                            require('@/assets/img/hdd/empty-1.png')
                                                .default
                                        }></img>
                                    <div className="desc">暂无相关模型</div>
                                </div>
                            </div>
                        )}
                    </Content>
                </Layout>
            </Layout>

            <CeilingModals
                detail={detail}
                deleteOpen={deleteOpen}
                setDeleteOpen={setDeleteOpen}
                moveOpen={moveOpen}
                setMoveOpen={setMoveOpen}
                editOpen={editOpen}
                setEditOpen={setEditOpen}
                detailOpen={detailOpen}
                setDetailOpen={setDetailOpen}
                treeData={moveTreeData}
                forceUpdate={forceUpdate}
                setPage={setPage}
                list={list}
                publishOpen={publishOpen}
                setPublishOpen={setPublishOpen}
                publishTreeData={publishTreeData}
                publishTreeLoading={publishTreeLoading}
            />
        </div>
    );
}
